export interface ErrorNoticeInput {
  lastRunError: { responseId: string; message: string } | null;
  liveTurn: { responseId: string | undefined; responseText: string } | undefined;
}

/** Whether the current live run has a user-visible failure for the dock's branded recovery copy. */
export function resolveErrorNotice(input: ErrorNoticeInput): string | null {
  if (!input.lastRunError || input.liveTurn?.responseId !== input.lastRunError.responseId) {
    return null;
  }
  return input.lastRunError.message;
}
